<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records checkup-section">
            <div class="row">
                <div class="col-md-12 col-12 mb-4">
                    <div class="card border-0">
                        <div class="card-body p-0">
                            <div class="bg-body border-radius-5">
                                <div class="card-header border-0 d-flex d-flex justify-content-between align-items-center bg-body p-0">
                                    <h2 class="mb-0">Featured Packages</h2>
                                    <form class="form-search position-relative single-post-search">
                                        <button class="btn button search"><i class="icon icon-search"></i></button>
                                        <input type="text" name="text" placeholder="Search Lab Test" />
                                    </form>
                                </div>
                                <div class="card-body p-0 mt-4">
                                    <div class="row no-gutter">
                                        <div class="col-md-4 col-sm-12 pl-3 mb-4">
                                            <div class="Comprehensive text-center bg-white border-1 border-radius-8 p-3 position-relative">
                                                <div class="Checkup text-left d-flex justify-content-between mb-2">
                                                    <h3>Comprehensive Full Body Checkup</h3>
                                                    <div class="Safe-button">
                                                        <a href="#" class="btn btn-yello-light"><i class="icon icon-shield"></i> Safe</a>
                                                    </div>
                                                </div>
                                                <div class="Includes">
                                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                                        <h4 class="mb-o">Includes 91 Tests</h4>
                                                        <figure class="mb-0 gini-labs"><img src="../../../../static/website/images/gini-labs.svg" alt="" /></figure>
                                                    </div>
                                                    <ul class="mb-3">
                                                        <li><a href="#">Nitrites</a></li>
                                                        <li><a href="#">Glycosylated Hemoglobin</a></li>
                                                        <li><a href="#">Vitamin B12</a></li>
                                                        <li><a href="#">Microalbumin/Creatinine Ratio</a></li>
                                                    </ul>
                                                    <router-link to="/recommended-checkup" class="more-test d-flex align-items-center"><i class="icon icon-plus"></i>more</router-link >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-sm-12 pl-3 mb-4">
                                            <div class="Comprehensive text-center bg-white border-1 border-radius-8 p-3 position-relative">
                                                <div class="Checkup text-left d-flex justify-content-between mb-2">
                                                    <h3>Comprehensive Full Body Checkup</h3>
                                                    <div class="Safe-button">
                                                        <a href="#" class="btn btn-yello-light"><i class="icon icon-shield"></i> Safe</a>
                                                    </div>
                                                </div>
                                                <div class="Includes">
                                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                                        <h4 class="mb-o">Includes 91 Tests</h4>
                                                        <figure class="mb-0 gini-labs"><img src="../../../../static/website/images/gini-labs.svg" alt="" /></figure>
                                                    </div>
                                                    <ul class="mb-3">
                                                        <li><a href="#">Nitrites</a></li>
                                                        <li><a href="#">Glycosylated Hemoglobin</a></li>
                                                        <li><a href="#">Vitamin B12</a></li>
                                                        <li><a href="#">Microalbumin/Creatinine Ratio</a></li>
                                                    </ul>
                                                    <router-link to="/recommended-checkup" class="more-test d-flex align-items-center"><i class="icon icon-plus"></i>more</router-link>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-sm-12 mb-4">
                                            <div class="Comprehensive text-center bg-white border-1 border-radius-8 p-3 position-relative">
                                                <div class="Checkup text-left d-flex justify-content-between mb-2">
                                                    <h3>Comprehensive Full Body Checkup</h3>
                                                    <div class="Safe-button">
                                                        <a href="#" class="btn btn-yello-light"><i class="icon icon-shield"></i> Safe</a>
                                                    </div>
                                                </div>
                                                <div class="Includes">
                                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                                        <h4 class="mb-o">Includes 91 Tests</h4>
                                                        <figure class="mb-0 gini-labs"><img src="../../../../static/website/images/gini-labs.svg" alt="" /></figure>
                                                    </div>
                                                    <ul class="mb-3">
                                                        <li><a href="#">Nitrites</a></li>
                                                        <li><a href="#">Glycosylated Hemoglobin</a></li>
                                                        <li><a href="#">Vitamin B12</a></li>
                                                        <li><a href="#">Microalbumin/Creatinine Ratio</a></li>
                                                    </ul>
                                                    <router-link to="/recommended-checkup" class="more-test d-flex align-items-center"><i class="icon icon-plus"></i>more</router-link>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-sm-12 pl-3 mb-4">
                                            <div class="Comprehensive text-center bg-white border-1 border-radius-8 p-3 position-relative">
                                                <div class="Checkup text-left d-flex justify-content-between mb-2">
                                                    <h3>Comprehensive Full Body Checkup</h3>
                                                    <div class="Safe-button">
                                                        <a href="#" class="btn btn-yello-light"><i class="icon icon-shield"></i> Safe</a>
                                                    </div>
                                                </div>
                                                <div class="Includes">
                                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                                        <h4 class="mb-o">Includes 91 Tests</h4>
                                                        <figure class="mb-0 gini-labs"><img src="../../../../static/website/images/gini-labs.svg" alt="" /></figure>
                                                    </div>
                                                    <ul class="mb-3">
                                                        <li><a href="#">Nitrites</a></li>
                                                        <li><a href="#">Glycosylated Hemoglobin</a></li>
                                                        <li><a href="#">Vitamin B12</a></li>
                                                        <li><a href="#">Microalbumin/Creatinine Ratio</a></li>
                                                    </ul>
                                                    <router-link to="/recommended-checkup" class="more-test d-flex align-items-center"><i class="icon icon-plus"></i>more</router-link>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-sm-12 pl-3 mb-4">
                                            <div class="Comprehensive text-center bg-white border-1 border-radius-8 p-3 position-relative">
                                                <div class="Checkup text-left d-flex justify-content-between mb-2">
                                                    <h3>Comprehensive Full Body Checkup</h3>
                                                    <div class="Safe-button">
                                                        <a href="#" class="btn btn-yello-light"><i class="icon icon-shield"></i> Safe</a>
                                                    </div>
                                                </div>
                                                <div class="Includes">
                                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                                        <h4 class="mb-o">Includes 91 Tests</h4>
                                                        <figure class="mb-0 gini-labs"><img src="../../../../static/website/images/gini-labs.svg" alt="" /></figure>
                                                    </div>
                                                    <ul class="mb-3">
                                                        <li><a href="#">Nitrites</a></li>
                                                        <li><a href="#">Glycosylated Hemoglobin</a></li>
                                                        <li><a href="#">Vitamin B12</a></li>
                                                        <li><a href="#">Microalbumin/Creatinine Ratio</a></li>
                                                    </ul>
                                                    <router-link to="/recommended-checkup" class="more-test d-flex align-items-center"><i class="icon icon-plus"></i>more</router-link>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-sm-12 mb-4">
                                            <div class="Comprehensive text-center bg-white border-1 border-radius-8 p-3 position-relative">
                                                <div class="Checkup text-left d-flex justify-content-between mb-2">
                                                    <h3>Comprehensive Full Body Checkup</h3>
                                                    <div class="Safe-button">
                                                        <a href="#" class="btn btn-yello-light"><i class="icon icon-shield"></i> Safe</a>
                                                    </div>
                                                </div>
                                                <div class="Includes">
                                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                                        <h4 class="mb-o">Includes 91 Tests</h4>
                                                        <figure class="mb-0 gini-labs"><img src="../../../../static/website/images/gini-labs.svg" alt="" /></figure>
                                                    </div>
                                                    <ul class="mb-3">
                                                        <li><a href="#">Nitrites</a></li>
                                                        <li><a href="#">Glycosylated Hemoglobin</a></li>
                                                        <li><a href="#">Vitamin B12</a></li>
                                                        <li><a href="#">Microalbumin/Creatinine Ratio</a></li>
                                                    </ul>
                                                    <router-link to="/recommended-checkup" class="more-test d-flex align-items-center"><i class="icon icon-plus"></i>more</router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Page Wrapper -->
</template>
<script>
    export default {
        name: "recommended-checkup",
        data() {
            return {};
        },
        created(){
           this.pageName('Lab Test')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/checkup/recommended-checkup.vue